import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type ConsentCheckboxProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  required?: boolean;
  children: ReactNode;
};

export default function ConsentCheckbox({
  id,
  checked,
  onChange,
  required = false,
  children,
}: ConsentCheckboxProps) {
  return (
    <label className="consent-checkbox" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        required={required}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span>{children}</span>
    </label>
  );
}

export function LegalLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link to={to} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  );
}
